module.exports = __webpack_public_path__ + "img/Light Cloud.c6d1cb36.png";